import { ZCatalogRecord } from "src/business/records/ZCatalogRecord";

export const extractClassIdsFromRecord = (
  record?: ZCatalogRecord,
): string[] => {
  if (!record) return [];
  return record.classification.flatMap(({ classes }) =>
    classes.map(({ id }) => id),
  );
};
